(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icarus-header"]) return;
  try {
    
(() => {
  const header = document.querySelector('[data-scroll-header]');
  if (!header) return;

  let lastPosition = Math.max(0, window.scrollY);
  let upwardTravel = 0;
  let frameRequested = false;

  const revealDistance = () => Math.min(420, Math.max(220, window.innerHeight * 0.28));
  const mobileMenu = header.querySelector('.il-mobile-nav');
  const searchForm = header.querySelector('[data-header-search]');
  const searchToggle = header.querySelector('[data-header-search-toggle]');
  const searchInput = header.querySelector('[data-header-search-input]');

  const closeSearch = () => {
    searchForm?.classList.remove('is-open');
    searchToggle?.setAttribute('aria-expanded', 'false');
  };

  searchToggle?.addEventListener('click', () => {
    const opening = !searchForm.classList.contains('is-open');
    searchForm.classList.toggle('is-open', opening);
    searchToggle.setAttribute('aria-expanded', String(opening));
    if (opening) window.setTimeout(() => searchInput?.focus(), 180);
  });

  searchForm?.addEventListener('submit', (event) => {
    if (searchInput?.value.trim()) return;
    event.preventDefault();
    searchForm.classList.add('is-open');
    searchToggle?.setAttribute('aria-expanded', 'true');
    searchInput?.focus();
  });

  document.addEventListener('pointerdown', (event) => {
    if (!searchForm?.contains(event.target)) closeSearch();
  });

  searchForm?.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeSearch();
    searchToggle?.focus();
  });

  const refreshCartCount = async () => {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      header.querySelectorAll('[data-cart-count]').forEach((count) => {
        count.textContent = String(cart.item_count);
      });
      const cartLink = header.querySelector('.il-header-cart');
      if (cartLink) cartLink.setAttribute('aria-label', `Basket, ${cart.item_count} items`);
    } catch {
      return;
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    window.setTimeout(refreshCartCount, 900);
  }, true);
  document.addEventListener('cart:update', refreshCartCount);
  document.addEventListener('cart:refresh', refreshCartCount);

  const showHeader = () => {
    header.classList.remove('is-concealed');
    header.classList.add('is-revealed');
  };

  const hideHeader = () => {
    if (header.contains(document.activeElement) || mobileMenu?.open) return;
    header.classList.remove('is-revealed');
    header.classList.add('is-concealed');
  };

  const updateHeader = () => {
    const currentPosition = Math.max(0, window.scrollY);
    const movement = currentPosition - lastPosition;

    if (currentPosition <= 32) {
      upwardTravel = 0;
      showHeader();
    } else if (movement > 4) {
      upwardTravel = 0;
      if (currentPosition > 120) hideHeader();
    } else if (movement < -4) {
      upwardTravel += Math.abs(movement);
      if (upwardTravel >= revealDistance()) {
        showHeader();
        upwardTravel = 0;
      }
    }

    lastPosition = currentPosition;
    frameRequested = false;
  };

  header.classList.add('is-scroll-managed');
  if (lastPosition > 120) hideHeader();

  window.addEventListener('scroll', () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(updateHeader);
  }, { passive: true });

  header.addEventListener('focusin', showHeader);
  mobileMenu?.addEventListener('toggle', () => {
    if (mobileMenu.open) showHeader();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
